/**
 * File: tourLayoutUtils.ts
 * Path: apps/admin/src/modules/layout/utils/tourLayoutUtils.ts
 * Description: Where the tour's lit hole and its small box go, from the measured target and the window size.
 */

import type { CSSProperties } from "react";

export interface Box {
  top: number;
  left: number;
  width: number;
  height: number;
}

const GAP = 12;
const PAD = 6;
export const TIP_WIDTH = 340;

export const rectOf = (el: Element): Box => {
  const r = el.getBoundingClientRect();
  return { top: r.top, left: r.left, width: r.width, height: r.height };
};

/** The lit hole around the target, relative to the page frame. */
export const holeFor = (target: Box | null, frame: Box | null): Box | null =>
  target && frame
    ? {
        top: target.top - frame.top - PAD,
        left: target.left - frame.left - PAD,
        width: target.width + PAD * 2,
        height: target.height + PAD * 2,
      }
    : null;

/** The box sits under the thing, or above it when there is no room below. */
export const tipStyleFor = (
  target: Box | null,
  windowSize: { width: number; height: number },
): CSSProperties => {
  if (windowSize.width < 640) return { left: 16, right: 16, bottom: 16 };
  if (target) {
    const below = target.top + target.height + GAP + 190 < windowSize.height;
    return {
      width: TIP_WIDTH,
      left: Math.max(16, Math.min(target.left, windowSize.width - TIP_WIDTH - 16)),
      ...(below ? { top: target.top + target.height + GAP } : { bottom: windowSize.height - target.top + GAP }),
    };
  }
  return { width: TIP_WIDTH, left: (windowSize.width - TIP_WIDTH) / 2, top: windowSize.height / 3 };
};
